import { render, staticRenderFns } from "./PatentUpdateFieldsList.vue?vue&type=template&id=685bb692&"
import script from "./PatentUpdateFieldsList.vue?vue&type=script&lang=js&"
export * from "./PatentUpdateFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./PatentUpdateFieldsList.vue?vue&type=style&index=0&id=685bb692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports